//% Initialize all the large_card swipers on the current page if it is NOT set to custom
const large_card_snippets = document.querySelectorAll(".snippet.slider-card_large:not(.custom)");


//$ Loop through all the valid (none-custom) large_card swipers and initialize them
large_card_snippets.forEach((large_card_slider) => {
  init_large_card_slider(large_card_slider);
});


//# Function that sets up the large card slider system with bg images
function init_large_card_slider(snippet_selector) {
  // const slider_large_card = document.querySelector(snippet_selector);
  let slider_large_card;;

  //% Check if snippet_selector is an HTML element
  if (snippet_selector instanceof HTMLElement) {
    //$ If it is then use that HTML node as the parent element
    slider_large_card = snippet_selector;
  } else {
    //$ If it is not then use the argument string as the parent selector
    slider_large_card = document.querySelector(snippet_selector);
  }

  //% Exit if no parent element found
  if (!slider_large_card) {
    console.log("no container matching '" + snippet_selector + "' could be found");
    return;
  }

  //% DOM Elements
  const swiperEl = slider_large_card.querySelector("swiper-container");
  const swiper_slides = slider_large_card.querySelectorAll("swiper-slide");
  const btn_next = slider_large_card.querySelector(".btn.next");
  const btn_prev = slider_large_card.querySelector(".btn.prev");

  const image_container = slider_large_card.querySelector(".image-container");

  //todo This is optional and can be replaced by adding images to the container in the HTML
  //% Set up bg images based on data-image attribute on the slides
  swiper_slides.forEach((slide, index) => {
    //$ Get image source from data attr
    const img_src = slide.dataset?.image;

    //$ Create new image element and set it's attributes
    const new_image = document.createElement("img");
    new_image.src = img_src;
    new_image.classList.add("hidden");

    //$ Append new image to image container
    image_container.appendChild(new_image);
  });

  //% Set up the swiper
  const params = {
    loop: true,
    navigation: {
      prevEl: btn_prev,
      nextEl: btn_next,
    },
    grabCursor: true,

    breakpoints: {
      0: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
      1024: {
        spaceBetween: 45,
        slidesPerView: 1.15,
      },
      2100: {
        spaceBetween: 300,
        slidesPerView: 1.3,
      },
    },

    on: {
      init: (swiper) => {
        //% Show the first image on init
        image_container.children[swiper.realIndex].classList.remove("hidden");
      },
      slideChange: (swiper) => {
        //% Add hide class to all the images
        Array.from(image_container.children).forEach((img) => {
          img.classList.add("hidden");
        });
        //% Remove hide class from image that matches current index
        image_container.children[swiper.realIndex].classList.remove("hidden");
      },
    },
  };

  swiper_init(swiperEl, params);
}
